import { HTMLAttributes } from 'react';

export const MainTitle = (props: HTMLAttributes<{}>) => (
    <h2
        {...props}
        className="font-mont mt-0 xl:mt-6 text-2xl font-extrabold text-gray-900"
    />
);
